export default __webpack_public_path__ + "static/media/logoTop.3116f66e.svg";